export default __webpack_public_path__ + "static/media/Opposites02_11.268a5997.png";